import { PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

type Props = PropsWithChildren<{
  className?: string
}>

const Label = (props: Props): ReactElement => {
  const { className, children } = props

  return <label className={classNames('label', className)}>{children}</label>
}

export default Label